/**
 * Axios HTTP Client Configuration
 * Centralized API client with interceptors, error handling, and token management
 * 
 * @author Varun Pandey
 */

import axios, { AxiosInstance } from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_PATH || 'https://artist-api.starclinch.com/api/';

// Create axios instance
export const apiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // For cookie-based auth on web
});

export default apiClient;
